import { render, staticRenderFns } from "./deliverDetail.vue?vue&type=template&id=4ba67865&scoped=true&"
import script from "./deliverDetail.vue?vue&type=script&lang=js&"
export * from "./deliverDetail.vue?vue&type=script&lang=js&"
import style0 from "./deliverDetail.vue?vue&type=style&index=0&id=4ba67865&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba67865",
  null
  
)

export default component.exports